import { render, staticRenderFns } from "./ImageGenerateNote.vue?vue&type=template&id=2fcd4bb7&"
import script from "./ImageGenerateNote.vue?vue&type=script&lang=js&"
export * from "./ImageGenerateNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports